import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-admin-user-view',
  templateUrl: './admin-user-view.component.html',
  styleUrls: ['./admin-user-view.component.scss'],
})
export class AdminUserViewComponent implements OnInit {

  viewUser: any = {};
  usersRoles: any;

  constructor(private router: Router, public route: ActivatedRoute, private g: Globals, public user: User, private api: ApiIntegration) {
    this.g.loaderDisplay = "display";
    this.api.getAdminUserById(this.route.snapshot.params['id'], this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.viewUser = data;
      this.usersRoles = this.viewUser.usersRoles;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  editUser() {
    this.router.navigate(['/admin/userRoleEdit/' + this.viewUser.id]);
  }

  ngOnInit() { }

}

